import { Swiper } from 'swiper';
// The bare `swiper` entry point is core-only, so Pagination has to be
// registered explicitly for the `pagination` option below to do anything.
import { Pagination } from 'swiper/modules';

// Removing all required data placeholder
const stI = document.getElementById('st-i');
stI.parentElement.removeChild(stI);

//review
$('.goto-reviews').click(function () {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        $('body, html').animate({
            scrollTop: $("[name='review']").offset().top,
        }, 500);
    } else {
        $('body, html').animate({
            scrollTop: $("[name='review']").offset().top - 164,
        }, 500);
    }
});

$(document).ready(function () {
    // Only rendered when the company has photos or a video.
    if (document.querySelector('.swiper')) {
        new Swiper('.swiper', {
            modules: [Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            loop: true,
            height: 380,
            direction: 'horizontal',
        });
    }
});
